import { useCallback, useState } from "react";
import { getClientDomain, getToken, setAvalibleTypesIncidents,getAvalibleTypesIncidents, setAvaliblePriorityIncidents, getAvaliblePriorityIncidents, getAvalibleStatusIncidents, setAvalibleStatusIncidents, handleStorage } from "../utils/Common";

export const useIncidents = () => {
    const [typesIncidents, setTypesIncidents] = useState(getAvalibleTypesIncidents() ? getAvalibleTypesIncidents() : null);
    const [priorityIncidents, setPriorityIncidents] = useState(getAvaliblePriorityIncidents() ? getAvaliblePriorityIncidents() : null);
    const [statusIncidents, setStatusIncidents] = useState(getAvalibleStatusIncidents() ? getAvalibleStatusIncidents() : null);
    const [originsIncidents, setOriginsIncidents] = useState(handleStorage('get', 'session', 'origins-incidents') || null);

    const getIncidents = useCallback(async (data, signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/incidents/all`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();

        return {
            code: result.code,
            payload: Array.isArray(result.payload) ? result.payload : [],
            totalItems: result.totalItems,
            statusCounts: Array.isArray(result.statusCounts) ? result.statusCounts : [],
        };
    }, []);
    
    const getTypes = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/incidents/types`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) {
            setAvalibleTypesIncidents(result.payload);
            setTypesIncidents(result.payload);
            return (result.payload);
        }
        else {
            setAvalibleTypesIncidents([])
            setTypesIncidents([]);
            return ([])
        }

    }, []);

    const getPriorities = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/incidents/priorities`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) {
            setAvaliblePriorityIncidents(result.payload);
            setPriorityIncidents(result.payload);
            return (result.payload);
        }
        else {
            setAvaliblePriorityIncidents([])
            setPriorityIncidents([]);
            return ([])
        }

    }, []);

    
    const getStatus = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/incidents/status`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) {
            setAvalibleStatusIncidents(result.payload);
            setStatusIncidents(result.payload);
            return (result.payload);
        }
        else {
            setAvalibleStatusIncidents([])
            setStatusIncidents([]);
            return ([])
        }

    }, []);

    const registerIncident = useCallback(async (data, signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/incidents/register`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();
        
        return (result);
    }, []);

    const getPresignedUploadUrl = useCallback(async (fileName, contentType, signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/incidents/presigned-upload-url`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify({ fileName, contentType }),
            signal: signal
        });

        const result = await response.json();
        if (result?.code === 200 && result?.payload) return result.payload;
        throw new Error(result?.message || 'ERROR_GETTING_PRESIGNED_URL');
    }, []);

    const getDetailsIncident = useCallback(async (id, signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/incidents/details/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) return (result.payload[0]);
        else return ([]);
    }, []);

    const updateIncident = useCallback(async (data, signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/incidents/update`, {
            method: 'PUT',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            body: JSON.stringify(data),
            signal: signal
        });

        const result = await response.json();
        if (result?.payload) return (result.payload);
        else return ([]);
    }, []);

    const getTrackingIncident = useCallback(async (id, signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/incidents/tracking/${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) return (result.payload);
        else return ([]);
    }, []);

    const getAllIncidents = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/incidents/all`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });
        const result = await response.json();
        
        if (result.payload?.length > 0) return (result.payload);
        else return ([]);
    }, []);


      const getViewUrlFile = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/incidents/signed-url`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              authorization: `Bearer ${getToken()}`,
            },
            body: JSON.stringify(data),
            signal: signal,
          });
      
      
        const result = await response.json();
        const payload = result.payload;
        if (payload == null) return null;
        if (typeof payload === "string") return payload;
        if (
          typeof payload === "object" &&
          !Array.isArray(payload) &&
          typeof payload.url === "string"
        ) {
          return payload.url;
        }
        if (Array.isArray(payload) && payload.length > 0) {
          const first = payload[0];
          if (typeof first === "string") return first;
          if (first && typeof first.url === "string") return first.url;
        }
        return null;
      }, []);

      const getStatsIncidents = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/incidents/stats`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${getToken()}`,
                },
                signal: signal,
                body: JSON.stringify(data),
            });
            const result = await response.json();
            return result.payload || [];
        }
    , []);

    // KPIs de resolución por rango de fechas (dateFrom/dateTo YYYY-MM-DD)
    const getResolutionStats = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/incidents/stats/resolution`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${getToken()}`,
            },
            signal: signal,
            body: JSON.stringify(data),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result?.message || "ERROR_GETTING_RESOLUTION_STATS");
        return result.payload;
    }, []);

    // Reporte consolidado de incidencias para una semana, un mes o un rango libre
    const getIncidentReport = useCallback(async (signal, data) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/incidents/report`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                authorization: `Bearer ${getToken()}`,
            },
            signal: signal,
            body: JSON.stringify(data),
        });
        const result = await response.json();
        if (!response.ok) throw new Error(result?.message || "ERROR_GETTING_INCIDENT_REPORT");
        return result.payload;
    }, []);

    const getOrigins = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/incidents/origins`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
           if (result?.payload?.length > 0) {
            handleStorage('set', 'session', 'origins-incidents', result.payload);
            setOriginsIncidents(result.payload);
            return (result.payload);
        }
        else {
            handleStorage('set', 'session', 'origins-incidents', []);
            setOriginsIncidents([]);
            return ([])
        }

    }, []);

    const getAssignedUsersSupport = useCallback(async (signal) => {
        const response = await fetch(`${getClientDomain(2)}/dashboard/incidents/autorized-users`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'authorization': `Bearer ${getToken()}`
            },
            signal: signal
        });

        const result = await response.json();
        if (result?.payload?.length > 0) return (result.payload);
        else return ([]);
    }, []);

    return { typesIncidents, priorityIncidents, statusIncidents, getIncidents, getTypes, getPriorities, registerIncident, getPresignedUploadUrl, getStatus, getDetailsIncident, updateIncident, getTrackingIncident, getAllIncidents, getViewUrlFile, getStatsIncidents, getResolutionStats, getIncidentReport, getOrigins, originsIncidents, getAssignedUsersSupport };
}